import React, { useState, useEffect } from 'react'

import { ContainerCad } from './../../components/Container'
import { Input, ValidacaoYup } from './../../components/Form'

function LocalizacaoFisica() {

    const validaCampos = {
        descricao: ValidacaoYup.string().required()
    }

    function onStackData(data) {
        return data.map(item => {
            const descricao = item.dados[0];
            let criado_por_raw = item.dados[1];
            let avatar_raw = item.dados[2];

            const firstName = criado_por_raw ? criado_por_raw.split(' ')[0] : '';
            let criadoPorHtml = '';

            if (avatar_raw && (avatar_raw.includes('http') || avatar_raw.includes('data:image'))) {
                criadoPorHtml = `
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <img src="${avatar_raw}" style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;" />
                        <span style="color: var(--color-text-primary); font-size: 13px;">${firstName}</span>
                    </div>
                `;
            } else {
                criadoPorHtml = `
                    <div style="display: flex; align-items: center; gap: 8px;">
                         <div style="width: 24px; height: 24px; border-radius: 50%; background-color: #eee; display: flex; align-items: center; justify-content: center; font-size: 10px;">${firstName.charAt(0)}</div>
                        <span style="color: var(--color-text-primary); font-size: 13px;">${firstName}</span>
                    </div>
                `;
            }

            return {
                ...item,
                dados: [descricao, criadoPorHtml]
            };
        })
    }

    return (
        <ContainerCad
            title='Localização Física'
            titlesub='Cadastro / Localização Física'
            router='localizacaofisica'
            onStackData={onStackData}
            thead={[
                { nome: 'Descrição' },
                { nome: 'Criado por', tamanho: 150 },
            ]}
            validacao={validaCampos}
            emptyStateText="Nenhuma localização física cadastrada"
        >

            <div className="row">
                <Input name='descricao' titulo='Descrição' placeholder='Digite a descrição' col='col-lg-12' />
            </div>

        </ContainerCad>
    )
}

export default LocalizacaoFisica